export const MOCK_PROVIDER_PROFILE = {
  id: 1,
  provider_id: 1,
  email: "finance@acmebank.gh",
  phone: "+233201234567",
  name: "Acme Rural Bank Ltd.",
  legal_name: "Acme Rural Bank Ltd.",
  institution: "Acme Rural Bank Ltd.",
  code: "ACME",
  status: "active",
  agreed_sla_days: 20,
  business_type: "Rural Bank",
  region: "Greater Accra",
  city: "Accra",
  gps_address: "GA-123-4567",
  website: "https://acmebank.gh",
  secondary_email: "collections@acmebank.gh",
  secondary_phone_number: "233201234568",
  socials: {
    instagram: "https://instagram.com/acmebank",
    x: "https://x.com/acmebank",
    facebook: "https://facebook.com/acmebank",
    tiktok: "",
    youtube: "",
  },
  channels: { sms: true, email: true, whatsapp: true },
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

let activeOtp = null;
let activeIdentifier = null;

function generateOtp() {
  return String(Math.floor(100000 + Math.random() * 900000));
}

function normalizeIdentifier(identifier) {
  return String(identifier ?? "").trim();
}

function resolveChannel(identifier) {
  const value = normalizeIdentifier(identifier);
  if (value.includes("@")) {
    return { channel: "email", value: value.toLowerCase() };
  }
  const phone = value.replace(/[\s-]/g, "");
  if (/^\+?\d{9,15}$/.test(phone)) {
    return { channel: "phone", value: phone };
  }
  return null;
}

function matchesMockUser(channel, value) {
  if (channel === "email") return MOCK_PROVIDER_PROFILE.email === value;
  const userPhone = MOCK_PROVIDER_PROFILE.phone.replace(/[\s-]/g, "");
  return value === userPhone || value === userPhone.replace(/^\+/, "");
}

export async function mockRequestLoginOtp(identifier) {
  await delay(900);

  const resolved = resolveChannel(identifier);
  if (!resolved) {
    throw new Error("Enter a valid email address or phone number.");
  }

  if (!matchesMockUser(resolved.channel, resolved.value)) {
    throw new Error(
      resolved.channel === "email"
        ? "No provider account found with this email."
        : "No provider account found with this phone number."
    );
  }

  activeOtp = generateOtp();
  activeIdentifier = resolved.value;

  return {
    identifier: resolved.value,
    channel: resolved.channel,
    expires_in: 600,
    demo_otp: activeOtp,
    message:
      resolved.channel === "email"
        ? "OTP sent to your email."
        : "OTP sent to your phone via SMS.",
  };
}

export async function mockVerifyLoginOtp(identifier, otp) {
  await delay(900);

  const resolved = resolveChannel(identifier);
  if (!resolved || resolved.value !== activeIdentifier) {
    throw new Error("Session expired. Please request a new verification code.");
  }

  if (String(otp).trim() !== activeOtp) {
    throw new Error("Invalid verification code. Please try again.");
  }

  activeOtp = null;
  activeIdentifier = null;

  return {
    token: "mock-jwt-token-" + Date.now(),
    token_type: "Bearer",
    expires_in: 86400,
    user: { ...MOCK_PROVIDER_PROFILE },
  };
}

export async function mockResendLoginOtp(identifier) {
  const resolved = resolveChannel(identifier);
  if (!resolved || resolved.value !== activeIdentifier) {
    throw new Error("Session expired. Please start again.");
  }
  return mockRequestLoginOtp(identifier);
}

export function getMockCredentialsHint() {
  return {
    email: MOCK_PROVIDER_PROFILE.email,
    phone: MOCK_PROVIDER_PROFILE.phone,
    note: "A demo OTP popup appears after you request a code.",
  };
}

export function getMockDemoAccounts() {
  return [
    {
      email: MOCK_PROVIDER_PROFILE.email,
      phone: MOCK_PROVIDER_PROFILE.phone,
      name: MOCK_PROVIDER_PROFILE.name,
    },
  ];
}
